import styled from 'styled-components';
import { cssColorValue, screenXsMax } from '@spotify-internal/encore-web';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding: 70px;
  text-align: center;
  background: ${cssColorValue('backgroundBase')};
`;

export const Header = styled.h1`
  display: block;
  margin: 0 0 20px 0;
  font-weight: 800;
  font-size: 1.5rem;
`;

export const Content = styled.div`
  padding: 0 15%;
  color: ${cssColorValue('textSubdued')};
  font-size: 1rem;
  line-height: 1.5;

  a {
    color: inherit;
    text-decoration: underline;
  }

  @media (max-width: ${screenXsMax}) {
    padding: 0;
  }
`;
